import React from "react";
import { ResponsiveMode } from "store/reducers/responsive";
import { useResponsiveMode } from "store/selectors/hooks";

interface Props {
    position?: "top" | "bottom";
    children: React.ReactNode;
}

export const Ribbon: React.FC<Props> = ({ position, children }) => {
    const responsiveMode = useResponsiveMode();
    const isMobile =
        responsiveMode === ResponsiveMode.small ||
        responsiveMode === ResponsiveMode.medium;

    if (isMobile) {
        if (position === "top") {
            return (
                <div className="flex items-center gap-2 bg-gray-200 p-2 rounded-t">
                    {children}
                </div>
            );
        }
        if (position === "bottom") {
            return (
                <div className="flex items-center gap-2 bg-gray-200 p-2 rounded-b overflow-x-auto">
                    {children}
                </div>
            );
        }
        return null;
    }

    if (position === "bottom") {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center gap-1 sm:gap-2 lg:gap-4 bg-gray-200 p-2 rounded-t">
            {children}
        </div>
    );
};
